import React from 'react';
import cn from 'classnames';

import TooltipForReceptionist from 'components/TooltipForReceptionist';
import IN from 'constants/in';
import { NO } from 'constants/no';
import { withTranslation } from 'providers/GILT.provider';
import { withTheme } from 'providers/Theme.provider';
import logger from 'utils/logger.util';

import DropdownContainer from 'onboarding/common/forms/common/Popup';

import RoleCheckboxContainer from './RoleCheckbox';

import CN from './AddServiceWithRole.module.scss';

const L = logger('AddServiceWithRole');

class AddServiceWithRole extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      clicked: false,
      selectPopupModal: false,
      selectedCategory: props.selectedCategory,
    };
  }

  onCategoryClick = () => {
    this.setState({ selectPopupModal: true });
  };
  onCheckboxClick = (roleId) => {
    if (!this.state.clicked) {
      this.setState({ clicked: true });
    }
    this.props.onCheckboxChange(roleId);
  };
  onPrincingChange = () => {
    if (!this.props.quickSetupLayout) {
      this.props.onPrincingChange(!this.props.service.variable_pricing);
    }
  };
  onPopupClose = () => {
    this.setState({ selectPopupModal: false });
  };
  onSelectItem = (item) => {
    const { categories } = this.props;
    for (let i = 0; i < categories.length; i += 1) {
      const currentCategory = categories[i];
      if (item.id === currentCategory.id) {
        this.setState({ selectedCategory: currentCategory, selectPopupModal: false });
        if (this.props.settingsLayout) {
          this.props.onCategoryChangeInSettings &&
            this.props.onCategoryChangeInSettings(this.props.service, currentCategory);
        } else {
          this.props.onCategoryChange(currentCategory);
        }
        break;
      }
    }
  };

  render() {
    const { selectedCategory, selectPopupModal } = this.state;

    const {
      onPriceChange,
      onProcessingChange,
      onApplicationChange,
      onPriceBlur,
      quickSetupLayout,
      serviceId,
      service,
      roles,
      categories,
      isDarkMode,
      t,
    } = this.props;

    // all needed items for the dropdown

    const selectedCategoryId = selectedCategory && selectedCategory.id;
    const items = categories.map(({ id, name }) => ({
      id: id || NO.id,
      name,
      active: !!(selectedCategoryId && selectedCategoryId === id),
    }));

    const componentClasses = cn({
      [CN.component]: true,
      [CN.darkMode]: isDarkMode,
    });

    L.debug('render()', serviceId, service, { selectedCategoryId, roles });

    return (
      <div data-bem="AddServiceWithRole" className={componentClasses}>
        {selectPopupModal && categories.length && (
          <DropdownContainer
            title={t('composite.addService.dropdownTitle')}
            items={items}
            onClose={this.onPopupClose}
            onSelectItem={this.onSelectItem}
          />
        )}
        {categories.length > 0 && (
          <div>
            <label htmlFor="ServiceTypeSelect">
              {t('composite.addService.serviceCategory')}
              <button className="utl-full-width select-button" id="ServiceTypeSelect" onClick={this.onCategoryClick}>
                <span className="select-button-bullet" style={{ backgroundColor: selectedCategory.color }} />
                <span className={CN.dropdownName}>{selectedCategory.name}</span>
                <span className="select-button-icon">
                  <span className="ic-sml ic_expand_more_black" />
                </span>
              </button>
            </label>
            <div className="input-baseline" />
            <div className="input-prompt-hide">
              <div className="input-baseline" />
              <span>{t('composite.addService.errorMessage')}</span>
            </div>
          </div>
        )}
        <div data-bem="AddServiceWithRole__roles-container">
          <label style={{ marginTop: 25, marginBottom: 10 }} htmlFor="roles">
            {!quickSetupLayout && <span className="input-label">{t('composite.addService.selectStylistLabel')}</span>}
            <div data-bem="AddServiceWithRole__roles-list" id="roles">
              {roles.map((role) => {
                const roleId = role.id;
                const key = `${roleId}-${serviceId || `unknown`}`;
                return (
                  <div data-bem={`AddServiceWithRole__role--${key}`} key={key} className="relative">
                    <RoleCheckboxContainer
                      role={role}
                      readOnly={quickSetupLayout}
                      service={service}
                      onClick={this.onCheckboxClick}
                      onPriceChange={onPriceChange}
                      onPriceBlur={onPriceBlur}
                      onApplicationChange={onApplicationChange}
                      onProcessingChange={onProcessingChange}
                    />
                    <TooltipForReceptionist where={IN.role} />
                  </div>
                );
              })}
            </div>
          </label>
        </div>
        <div className="center-align">
          <div className="checkbox-custom-wrap">
            <input
              type="checkbox"
              className="checkbox-custom"
              id="VariablePricing"
              onChange={this.onPrincingChange}
              checked={service && service.variable_pricing}
            />
            <label className="checkbox-custom-label" htmlFor="VariablePricing">
              {t('composite.addService.checkboxLabel')}
              <div className="checkbox-custom-icon">
                <span className="ic-sml-16px ic_check_white" />
              </div>
            </label>
          </div>
        </div>
      </div>
    );
  }
}

const AddServiceWithRoleHoc = withTranslation()(withTheme()(AddServiceWithRole));

export default AddServiceWithRoleHoc;
